import * as React from 'react';

import { PostType } from '@blockworks/platform/api/strapi';
import { Spinner } from '@blockworks/ui';

import { withExceptionCatcher } from '@/components/hoc/with-exception-catcher';
import NewsArticlePage from '@/components/pages/news-article/layout/news-article-page';
import type { ArticleType, Event } from '@/types/article-type';
import { Category } from '@/utils/functions/wordpress/fetch-categories';

export interface NewsArticlePageControllerProps {
    article: ArticleType;
    recentResearch: PostType;
    categories: Category[];
    readMoreArticles: ArticleType[];
    upcomingEvents: Event[];
    isPreviewMode: boolean;
    previewModeId: string;
}

export const NewsArticlePageController = ({
    isPreviewMode,
    previewModeId,
    article,
    recentResearch,
    categories,
    readMoreArticles,
    upcomingEvents,
}: NewsArticlePageControllerProps) => {
    if (!article) {
        return (
            <div className="p-12">
                <Spinner />
            </div>
        );
    }

    const openWordpressTab = async (id: string) => {
        try {
            window.open(`https://cms.blockworks.co/wp-admin/post.php?post=${id}&action=edit`, '_blank');
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    return (
        <>
            {isPreviewMode && (
                <div className="bg-yellow-500 text-black p-2 fixed top-0 left-0 w-full z-50">
                    <div className="container mx-auto text-center">
                        <p className="font-bold">⚠️ Currently viewing Preview Mode for article id {previewModeId}!</p>

                        <p className="inline text-gray-700 text-sm mt-1"> To open this post in wordpress. click </p>
                        <button
                            onClick={() => openWordpressTab(previewModeId)}
                            className="inline-block text-blue-700 underline hover:text-blue-900"
                        >
                            here.
                        </button>
                    </div>
                </div>
            )}

            <NewsArticlePage
                article={article}
                recentResearch={recentResearch}
                categories={categories}
                upcomingEvents={upcomingEvents}
                readMoreArticles={readMoreArticles}
            />
        </>
    );
};

export default withExceptionCatcher(NewsArticlePageController);
